import { z } from 'zod';
import { APP_CONSTRAINTS, APP_VALIDATION_PATTERNS } from '@/lib/constants/app';

const c = APP_CONSTRAINTS;
const p = APP_VALIDATION_PATTERNS;

const optionalPatternField = (pattern: RegExp, max: number) =>
  z
    .string()
    .max(max)
    .refine((val) => val === '' || pattern.test(val), { message: 'Invalid format' });

export const appGeneralFormSchema = z.object({
  name: z.string().min(c.NAME_MIN, 'Name is required').max(c.NAME_MAX).trim(),
  desc: z.string().max(c.DESC_MAX),
  websiteDomainPath: z.string().max(c.WEBSITE_MAX),
  rootLlId: z.number().positive('Content Group is required'),
  defaultPlayerId: z.number().positive('Player is required'),
  isChildTargeted: z.boolean(),
  spotlightCatLLId: z.string(),
  heroStyle: z.enum(['card', 'immersive']),
  tileTitleTreatment: z.enum(['below_card', 'none']),
  fbId: optionalPatternField(p.FB_ID, c.FB_ID_MAX),
  igId: optionalPatternField(p.IG_ID, c.IG_ID_MAX),
  xId: optionalPatternField(p.X_ID, c.X_ID_MAX),
  ytId: optionalPatternField(p.YT_ID, c.YT_ID_MAX),
  gaId: optionalPatternField(p.GA_ID, c.GA_ID_MAX),
});

export type AppGeneralFormSchemaData = z.infer<typeof appGeneralFormSchema>;
